import { render, staticRenderFns } from "./workshop-devices-table.vue?vue&type=template&id=5dc50f00"
import script from "./workshop-devices-table.vue?vue&type=script&lang=js"
export * from "./workshop-devices-table.vue?vue&type=script&lang=js"
import style0 from "./workshop-devices-table.vue?vue&type=style&index=0&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports